import API from '../configs/axiosInstance';

const appendParams = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    if (typeof value === 'boolean') {
      if (value) search.append(key, 'true');
      return;
    }
    search.append(key, value);
  });
  const q = search.toString();
  return q ? `?${q}` : '';
};

const getSummary = ({ signal } = {}) =>
  API({
    url: '/account-service/v1/cve/summary',
    method: 'GET',
    signal,
  });

const getEpssDistribution = ({ epssRange, kevOnly, signal } = {}) =>
  API({
    url: `/account-service/v1/cve/epss-distribution${appendParams({ epssRange, kevOnly })}`,
    method: 'GET',
    signal,
  });

const getVendors = ({ signal } = {}) =>
  API({
    url: '/account-service/v1/cve/vendors',
    method: 'GET',
    signal,
  });

const getProducts = ({ signal } = {}) =>
  API({
    url: '/account-service/v1/cve/products',
    method: 'GET',
    signal,
  });

const getTopProducts = ({ signal } = {}) =>
  API({
    url: '/account-service/v1/cve/top-products',
    method: 'GET',
    signal,
  });

const getTable = ({ search, epssRange, vendor, product, kevOnly, page, size, signal } = {}) =>
  API({
    url: `/account-service/v1/cve/table${appendParams({
      search,
      epssRange,
      vendor,
      product,
      kevOnly,
      page,
      size,
    })}`,
    method: 'GET',
    signal,
  });

const getById = (cveId, { signal } = {}) =>
  API({
    url: `/account-service/v1/cve/${encodeURIComponent(cveId)}`,
    method: 'GET',
    signal,
  });

const cveService = {
  getSummary,
  getEpssDistribution,
  getVendors,
  getProducts,
  getTopProducts,
  getTable,
  getById,
};

export default cveService;
